import { createFileRoute } from "@tanstack/react-router";
import { WorkPage } from "@/components/blocks/work/WorkPage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/realisations/")({
	component: WorkPage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("work", loaderData.locale, {
					structuredData: [buildPageBreadcrumb(loaderData.locale, ["work"])],
				})
			: {},
});
